module.exports = __webpack_public_path__ + "static/media/entreview-man-service-2.6cee6e49.png";